import React, {Suspense, useCallback, useContext, useEffect, useRef, useState, useTransition} from "react";
import {useTranslation} from "react-i18next";
import ThemeContext from "../../utils/contexts/themeContext";

// ******
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import config from "../../configuration/config.json";
import {Link, useHistory, useParams} from "react-router-dom";
import {Price} from "../../components/__simple/_price";
import SimpleButton from "../../components/_input/SimpleButton";
import {toast} from "react-toastify";
import moment from "moment";
import SMSCheck from "../cart/components/smsCheck";
import PopupWithHeading from "../../components/popupWithHeading";
import Popup from "../../components/popup";

const SparePartsSalesPage = () => {
    const {
        t: trans, i18n
    } = useTranslation(["mobileCommon", "mobileHeading", "messages", "new", "error", "info", "jobCard"]);
    let lang = i18n.language;
    const history = useHistory();
    const {number} = useParams();

    const themeMode = useContext(ThemeContext);
    // ** ** **
    const [isPayed, setIsPayed] = useState(1);
    const [isLoadingStatus, setIsLoadingStatus] = useState(false);
    const [SparePartStatus, setSparePartStatus] = useState("");
    const [sadadInfo, setSadadInfo] = useState(null);
    const [showFinalPopup, setShowFinalPopup] = useState(false);
    const [showTermsPopup, setShowTermsPopup] = useState(false);
    const [categories, setCategories] = useState([]);
    const [checkTamarClose, setCheckTamarClose] = useState(false);
    const [postedDate, setPostedDate] = useState('');
    const [salesOrder, setSalesOrder] = useState({});
    const [salesOrderAmounts, setSalesOrderAmounts] = useState(null);
    const [termsSalesOrders, setTermsSalesOrders] = useState([]);
    const [showInfo, setShowInfo] = useState(true);
    const [agreementShow, setAgreementShow] = useState(true);
    const [paymentType, setPaymentType] = useState(1);
    const [chickBTNPay, setChickBTNPay] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [optionTitle, setOptionTitle] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const popRef = useRef(null);
    const [salesOrderStatusCode, setSalesOrderStatusCode] = useState("");
    const [orderTrans, setOrderTrans] = useState(null);
    const [orderCustInfo, setOrderCustInfo] = useState(null);
    const [orderAuthorized, setOrderAuthorized] = useState(null);


    //************************************************
    const onSucessApple = async () => {

        if (!isLoading) {
            setShowPopup(false);
            await updatePaymentMethod("full");
        }
    }
    // **** ***** *****
    const popupSectionCallback = useCallback((orderStatusCode) => {

//todo: ------------
        console.log("popupSectionCallback:", orderStatusCode)
        console.log(" sadadInfo?.invoiceIDhhh:", sadadInfo?.SadadNumber)
        let fragment = <></>;
        switch (orderStatusCode) {
            case "Confirmed":
                fragment =
                    // jobCardInfo?.MaintenanceOrderID &&
                    salesOrder.SalesInvoiceID &&
                    <>
                        <div className="flex flex-row justify-center">
                            <span
                                className="text-34 font-bold text-gray mx-2"> {trans("jobCard:agreement_number")}</span>
                            <span
                                className="text-34 font-bold text-gray mx-2">{salesOrder && salesOrder.SalesInvoiceID}</span>
                        </div>


                        {
                            sadadInfo?.invoiceID &&
                            <div className="cart-finalized-code"

                                 onClick={() => {

                                     navigator.clipboard.writeText(sadadInfo?.invoiceID ? sadadInfo?.invoiceID : "");
                                     toast.success(trans("messages:copied_successfully"));
                                 }}
                            >
                                {/* <span className="text-34 font-bold text-gray mx-2"> {trans("new:sadad")}</span> */}
                                <code
                                    className="text-white text-30">{sadadInfo?.invoiceID ? sadadInfo?.invoiceID : ""}</code>
                                <img src="/assets/icons/copy.svg" alt='copy'/>
                            </div>
                        }
                    </>

                break;

            case "Finance":
                fragment =
                    <div className="flex flex-row justify-center">
                        <span className="text-34 font-bold text-gray mx-2"> {trans("new:sales_order_number")}</span>
                        <span
                            className="text-34 font-bold text-gray mx-2">{salesOrder && salesOrder?.SalesInvoiceID}</span>
                    </div>
                break;

            case "Cash By Branch":
                fragment =
                    <>
                        <div className="flex flex-row justify-center">
                            <span className="text-34 font-bold text-gray mx-2"> {trans("new:sales_order_number")}</span>
                            <span
                                className="text-34 font-bold text-gray mx-2">{salesOrder && salesOrder?.SalesInvoiceID}</span>
                        </div>
                        <div className="flex flex-row justify-center mb-10">
                            <span className="text-34 font-bold text-gray mx-2">{trans("new:message_By_Branch")}</span>
                        </div>
                    </>
                break;

            case "Canceled":
                fragment =
                    <div className="flex flex-row justify-center mb-10">
                        <span
                            className="text-34 font-bold text-gray mx-2">{trans("new:agreement_link_is_cancelled")}</span>
                    </div>
                break;

            case "notCorrect":
                fragment =
                    <div className="flex flex-row justify-center mb-10">
                        <span
                            className="text-34 font-bold text-gray mx-2">{trans("new:agreement_status_is_invalid")}</span>
                    </div>
                break;

            case "notFound":
                fragment =
                    <div className="flex flex-row justify-center mb-10">
                        <span
                            className="text-34 font-bold text-gray mx-2">{trans("new:link_is_incorrect")}</span>
                    </div>
                break;

            case "expired":
                fragment =
                    <div className="flex flex-row justify-center mb-10">
                        <span
                            className="text-34 font-bold text-gray mx-2">{trans("new:agreement_link_has_expired")}</span>
                    </div>
                break;
        }

        console.log(" fragment", fragment)


        return fragment

    }, [SparePartStatus, sadadInfo]);

    //** *** *
    const handelGoCheckSms = (applePayPram = false) => {

        // onSucess();
        console.log("handelGoCheckSms", applePayPram);
        if (!isLoading) {
            if (sadadInfo?.sadadNumber) {
                setShowFinalPopup(true);
                toast.success(trans("new:a_payment_number_has_already_been_created"));
                return;
            }

            if (!(salesOrder && salesOrder["Mobile"] != null && salesOrder["Mobile"] != "0")) {

                toast.success(trans("new:mobile_not_found"));
                return;
            }

            if (!(salesOrder && salesOrder["NetTotalAfterDisc"] != null && salesOrder["NetTotalAfterDisc"] != "0")) {

                toast.success(trans("new:The_amount_cannot_be_zero"));
                return
            }
            console.log("SparePartStatus", SparePartStatus)

            if (SparePartStatus?.toLowerCase() == "approved"){
             if (applePayPram == false){
                 console.log("Osama paymentType", paymentType);
                 // setShowPopup(true); //todo: ---- ترجع نفس ما كانت
                 // onSucess(); //todo: -- تبع التحقق

                 if (paymentType === 2 || paymentType === 4) {
                     setShowPopup(true); //todo: ---- ترجع نفس ما كانت
                 } else {
                     onSucess(); //todo: -- تبع التحقق
                 }
             }else {
                 console.info("applePayPram == true", applePayPram);
                 onSucessApple();
             }
            }


            // if (applePayPram == false && SparePartStatus == "Approved") {
            //
            //         if (paymentType) {
            //
            //             console.log("Osama paymentType", paymentType);
            //             // setShowPopup(true); //todo: ---- ترجع نفس ما كانت
            //             // onSucess(); //todo: -- تبع التحقق
            //
            //
            //             if (paymentType === 2 || paymentType === 4) {
            //                 setShowPopup(true); //todo: ---- ترجع نفس ما كانت
            //             } else {
            //                 onSucess(); //todo: -- تبع التحقق
            //
            //             }
            //         } else {
            //             toast.error(trans("new:please_define_pay_method"));
            //         }
            //
            // } else if (applePayPram == true && (SparePartStatus.toLowerCase() != 'Approved' || SparePartStatus.toLowerCase() != 'Posted')) {
            //     // } else if (applePayPram == true && (SparePartStatus.toLowerCase() == "confirmed" || SparePartStatus.toLowerCase() == "closed")) {
            //     console.info("applePayPram == true", applePayPram);
            //     onSucessApple();
            // }


            if (salesOrderStatusCode?.toLowerCase() == "ready") {
                if (paymentType) {
                    setShowPopup(true);
                } else {
                    toast.error(trans("new:please_define_pay_method"));

                }
            }
        }
    }

    //**
    const funcSadadNumber = async (numberSadad, resulteData) => {
        try {
            // var sadadNumber = response.data[0].sadadNumber.replaceAll('"', "");
            var sadadNumber = numberSadad;
            console.log("sadadNumber:", sadadNumber);
            if (sadadNumber && parseInt(sadadNumber)) {
                // var datasadad = response.data[0];
                let datasadad = resulteData;
                datasadad.sadadNumber = sadadNumber;
                setSadadInfo(datasadad);
            } else {
                // setSadadInfo(response?.data[0]);
                setSadadInfo(resulteData);
            }
        } catch (error) {
            // setSadadInfo(response?.data[0]);
            setSadadInfo(resulteData);
            console.log("error sadadNumber:", error);
        }

        // if (response.data[0].sadadNumber != null && response.data[0].sadadNumber != undefined) {
        if (numberSadad != null && numberSadad != undefined) {
            // setShowFinalPopup(true);
        } else {
            // await callback();
        }
    }

    const formatDateTime = useCallback((date, currentformat = null) => {
        try {
            if (date) {
                let dateNow = new Date(date)
                var formatDate;

                if (currentformat) {

                    formatDate = currentformat;
                } else {
                    formatDate = {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                    }

                }


                if (lang.language === 'en') {
                    return dateNow.toLocaleDateString('en-US', formatDate)
                } else {
                    return dateNow.toLocaleDateString('en-US', formatDate)
                }
            } else {
                return date
            }
        } catch (error) {
            console.log(error)
            return date
        }
    }, [])

    //*
    const updatePaymentMethod = async (PaymentTypeText) => {

        console.log("paymentMethodID>>>>>", PaymentTypeText, "PaymentTypeID>>>>>", PaymentTypeText)

        setIsLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var raw = {
            "paymentType": PaymentTypeText,
            "GUID": number,
            "Callback": window.location.origin + "/" + lang + `/sparePartsSales/${number}` // todo: نضيف المتغير من شان الرابط الي بايرجع
        };

        try {
            await axios.request({
                baseURL: config.controllerUrl,
                // url: "sadad/api/sadad/SendApprovedPayment_SI", //todo: في الكنترول لر
                url: "sadad/api/sadad/SendApprovedPayment_SO_SP", //todo: في الكنترول لر
                headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            })
                .then(response => {
                    console.log("SendApprovedPayment_SI response.status:", response.status);
                    if (response.status >= 200 && response.status <= 300) {
                        console.log("SendApprovedPayment_SI response.data:", response.data);
                        if (paymentType == 1 && PaymentTypeText == 'full') {
                            try {
                                if (response.data.URL_Paytabs != null) {
                                    // console.log(`Data Payment Paytabs:\n`, response.data.url_payment);
                                    window.location.href = response.data.URL_Paytabs;
                                } else if (response.data.MessageError != null && response.data.URL_Paytabs == null) {
                                    toast.warn(response.data.MessageError.toString());
                                } else {
                                    setIsLoading(false);
                                    toast.error(trans("error:unknown_failure"));
                                    console.log(">>>>>>>>>> if", trans("error:unknown_failure"));
                                    console.warn(">>>> MessageError: ", response.data.MessageError);
                                }
                            } catch (error) {
                                toast.error(trans("error:unknown_failure"));
                                console.log(">>>>>>>>>> catch 1", error, trans("error:unknown_failure"));
                            }
                        } else if (paymentType == 2) {
                            try {
                                if (response.data.url_payment) {
                                    console.log(`Data Payment Sadad:\n`, response.data.url_payment);
                                    window.location.href = response.data.url_payment;
                                } else {
                                    setIsLoading(false);
                                    toast.error(trans("error:unknown_failure"));
                                    console.log(">>>>>>>>>>Sadad if", trans("error:unknown_failure"));
                                    console.warn(">>>> MessageError: ", response.data.MessageError);
                                }
                            } catch (error) {
                                toast.error(trans("error:unknown_failure"));
                                console.log(">>>>>>>>>> Sadad catch 2", error, trans("error:unknown_failure"));
                            }
                        } else if (paymentType == 3) {
                            try {
                                if (response.data.url_payment) {
                                    console.log(`Data Payment Tamara:\n`, response.data.url_payment);
                                    window.location.href = response.data.url_payment;
                                } else {
                                    setIsLoading(false);
                                    toast.error(trans("error:unknown_failure"));
                                    console.log(">>>>>>>>>>Sadad if", trans("error:unknown_failure"));
                                    console.warn(">>>> MessageError: ", response.data.MessageError);
                                }
                            } catch (error) {
                                toast.error(trans("error:unknown_failure"));
                                console.log(">>>>>>>>>> Sadad catch 3", error, trans("error:unknown_failure"));
                            }
                        } else {
                            try {
                                if (response.data.url_payment) {
                                    console.log(`Data Payment else:\n`, response.data.url_payment);
                                    window.location.href = response.data.url_payment;
                                } else {
                                    setIsLoading(false);
                                    toast.error(trans("error:unknown_failure"));
                                    console.log(">>>>>>>>>>else if", trans("error:unknown_failure"));
                                    console.warn(">>>> MessageError: ", response.data.MessageError);
                                }
                            } catch (error) {
                                toast.error(trans("error:unknown_failure"));
                                console.log(">>>>>>>>>> else catch 0", error, trans("error:unknown_failure"));
                            }
                        }
                    }

                    setIsLoading(false);
                    // return response?.data;
                })
                .catch(error => {
                    console.log(error);
                    setIsLoading(false);
                })
        } catch (er) {
            setIsLoading(false);
            console.log("Catch Error :", er.toString())
        }
    }

    const onSucess = async () => {

        if (!isLoading) {
            setShowPopup(false);

            // const isLagout = window.confirm(trans("new:are_you_sure_you_have_completed_the_payment_process"));
            console.log("onSucess.paymentType:", paymentType);

            if (paymentType == 1) {
                console.log("paymentType: ", 1, "full");
                await updatePaymentMethod("full");
            } else if (paymentType == 2) {
                console.log("paymentType: ", 2, "sadad");
                await updatePaymentMethod("sadad");
            } else if (paymentType == 3) {
                console.log("paymentType: ", 3, "tamara");
                await updatePaymentMethod("tamara");
            } else {
                console.log("paymentType: ", 0, "uponReceipt");
                await updatePaymentMethod("uponReceipt");
            }

            // if (paymentType == 1) {
            //     // PayTabs();
            // } else if (paymentType == 2) {
            //     var val = await updatePaymentMethod("Financing", "Credit");
            //
            //     // if (val) {
            //     window.location.reload(true);
            //     // } else {
            //     //     toast.error(trans("error:unknown_failure"));
            //     // }
            // } else {
            //     var val = await updatePaymentMethod("CashByBranch", "Cash");
            //     // if (val) {
            //     window.location.reload(true);
            //     // } else {
            //     //     toast.error(trans("error:unknown_failure"));
            //     // }
            //
            // }


            // if (salesOrder?.CustPaymentMethodEN != paymentType?.CustPaymentMethodID) {
            //     try {
            //         const settingResponse = await axios.request({
            //             baseURL: '/',
            //             url: lang + "/api/Sadad/index",
            //             method: "get"
            //         });

            //         setSadadTypes(settingResponse.data.brands);
            //     } catch (error) {
            //         console.log(error);
            //     }
            // }
            // try {
            //     const Body = {
            //         "Object": "SalesOrders",
            //         "CommandName": "SalesMntc_CreateSadadInfoSO",
            //         "Values":
            //         {
            //             "Guid": number

            //         }
            //     }
            //     axios.request({
            //         url: config.baseURLSadad + 'Action',
            //         data: Body, method: "POST", responseType: "json"
            //     })
            //         .then(function (response) {
            //             //---------------------------------------------------
            //             const Body = {
            //                 "Object": "SalesOrders",
            //                 "CommandName": "SalesMntc_CreateSadadCodeSO",

            //                 "Values":
            //                 {
            //                     "Guid": number

            //                 }
            //             }
            //             axios.request({
            //                 url: config.baseURLSadad + 'Action',
            //                 data: Body, method: "POST", responseType: "json"
            //             })
            //                 .then(function (response) {
            //                     FetchSadadNumberApp();
            //                     setSadadInfo(response.data);

            //                     setShowFinalPopup(true);
            //                 })
            //                 .catch(function (error) {
            //                     toast.error(" حدث خطاء غير متوقع");
            //                     console.log(error);
            //                 });
            //             //----------------------------------------------------
            //         })
            //         .catch(function (error) {
            //             toast.error(" حدث خطاء غير متوقع");
            //             console.log(error);
            //         });
            // } catch (error) {
            //     toast.error(" حدث خطاء غير متوقع");
            //     console.log("error:", error);
            // }


        }
    }

    // * CheckSalesInoiceStatus
    const PaymentStatus = async () => {
        console.log('Fetch_SalesInvoiceTrans>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        try {
            await axios.request({
                url: config.controllerUrl + 'api/SparePartsSales/CheckStatus',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(async function (response) {
                    console.log("CheckSalesInoiceStatus:", response?.status);
                    if (response?.status >= 200 && response?.status <= 300) {
                        console.log("CheckSalesInoiceStatus:", response?.status);
                        console.log("CheckSalesInoiceStatus:", response?.data[0]);

                        if (response?.data[0].status == 0) {
                            console.log('CheckSalesInoiceStatus respons.data.status:', response?.data[0].status);
                            console.log('CheckSalesInoiceStatus respons.data.PaymentMethodID:', response?.data[0].PaymentMethodID);

                            setIsPayed(response?.data[0].status);
                            let labSadad = response?.data[0].PaymentMethodID;
                            console.info("labSadad: ", labSadad.toLowerCase() ?? "Null");
                            if (labSadad.toLowerCase() == 'sadad' && (response.data[0].SadadNumber != null || response.data[0].SadadNumber != undefined)) {
                                // ?    نرجع رقم سداد
                                await funcSadadNumber(response.data[0].SadadNumber, response.data[0]);
                            }
                            // setChickBTNPay(false);
                            // setShowFinalPopup(true);
                        }
                    }
                })
                .catch(async function (error) {
                    // setSalesOrderStatusCode("notFound");
                    // setShowFinalPopup(true);
                    await chickOrderStatus("notFound");
                    console.log(error);
                });
        } catch (error) {
            console.log("error:", error);
        }
    };

    //*
    const Fetch_SalesInvoiceTrans = async () => {
        console.log('Fetch_SalesInvoiceTrans>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        try {
            await axios.request({
                url: config.controllerUrl + 'api/SparePartsSales/FetchTransWeb',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(async function (response) {
                    console.log("Fetch_SalesInvoiceTrans:", response.status);
                    if (response.status >= 200 && response.status <= 300) {
                        console.log("Fetch_SalesInvoiceTrans:", response.status);
                        console.log("Fetch_SalesInvoiceTrans:", response.data);

                        if (response.data != null) {
                            setCategories(response.data);
                        }

                        for (const category of response.data) {
                            console.log("category: ", category)
                        }
                    }

                })
                .catch(async function (error) {
                    // setSalesOrderStatusCode("notFound");
                    // setShowFinalPopup(true);
                    await chickOrderStatus("notFound");
                    console.log(error);
                });
        } catch (error) {
            console.log("error:", error);
        }
    };

    //PaymentMAin
    async function PayTabs() {

        setIsLoading(true);
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = {
                "GUID": number, "Callback": window.location.origin + "/" + lang + "/salesOrder/"
            };
            axios.request({
                baseURL: config.controllerUrl,
                url: "sadad/api/sadad/PayTabs",
                headers: myHeaders,
                data: raw,
                method: "POST",
                responseType: "json"
            }).then(response => {
                console.log('PayTabs respons:', response);
                try {

                    if (response?.data?.URL_Paytabs) window.location.href = response.data.URL_Paytabs; else {
                        toast.error(trans("error:unknown_failure"));
                    }
                    // history.push(response.data.URL_Paytabs);
                } catch (error) {
                    toast.error(trans("error:unknown_failure"));
                }

                setIsLoading(false);
            }).then((response) => {
                console.log('response2', response);
                setIsLoading(false);
            }).catch(error => {
                console.log('erro PayTabs', error)
                setIsLoading(false);
                toast.error(trans("error:unknown_failure"));


            });
        } catch (error) {
            console.log('error PayTabs', error)
            setIsLoading(false);
            toast.error(trans("error:unknown_failure"));

        }
    }

    //PaymentMAin for changes
    async function callPaymentStatus() {
        console.log('callPaymentStatus>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        setIsLoadingStatus(true);
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = {

                "GUID": number
            };

            await axios.request({
                baseURL: config.controllerUrl,
                url: "sadad/api/sadad/PaymentStatus",
                headers: myHeaders,
                data: raw,
                method: "POST",
                responseType: "json"
            }).then(async response => {
                console.log('PaymentStatus respons:', response.data);

                setIsLoadingStatus(false);
            }).then((response) => {
                console.log('response2', response);
            }).catch(async error => {
                console.log('error PaymentStatus:', error)
                setIsLoadingStatus(false);
            });
        } catch (error) {
            console.log('error', error)
            setIsLoadingStatus(false);

        }


    }

    //**
    const GetTamaraStatusFlagSP = async () => {
        console.log('GetTamaraStatusFlagSP >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');

        try {
            await axios.request({
                url: config.controllerUrl + 'api/SparePartsSales/GetTamaraStatusFlagSOSP',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(async function (response) {
                    console.log("Fetch_SalesInvoice.Data:", response.data[0]);
                    setIsLoadingStatus(false);

                    if (response.status >= 200 && response.status <= 300) {

                        if (response.data != null && response?.data[0] != null && response?.data[0]['TamarClose'] != null) {
                            if (response?.data[0]['TamarClose'] == 0 && response?.data[0]['TamarClose'] == false) {
                                setCheckTamarClose(false);
                            } else if (response?.data[0]['TamarClose'] == 1 && response?.data[0]['TamarClose'] == true) {
                                setCheckTamarClose(true);
                            } else {
                                setCheckTamarClose(response?.data[0]['TamarClose']);
                            }
                        }

                        if (response?.data[0].PaymentDate != null) setPostedDate(response?.data[0].PaymentDate);
                    }
                })
                .catch(function (error) {
                    console.log("GetTamaraStatusFlagSP: ", error);
                });

        } catch (ex) {
            console.log("GetTamaraStatusFlagSP:Catch Error GetCenterInfo: ", ex)
        }
    }

    const chickOrderStatus2 = async (OrderStatus) => {
        //todo : ======

        if (OrderStatus == null || OrderStatus == undefined){
            setSparePartStatus("notCorrect");
            setShowFinalPopup(true);
        }

        if (OrderStatus == "Approved" || OrderStatus == "SentForPayment" || OrderStatus == "InProcess" || OrderStatus == "Created") {
            setSparePartStatus("Approved");
            await PaymentStatus();

        } else if (OrderStatus == "Canceled" || OrderStatus == "Closed") {
            setSparePartStatus("Canceled");
            setShowFinalPopup(true);

        } else if (OrderStatus == "Open" || OrderStatus?.toLowerCase() == 'delivered' || OrderStatus == "notFound") {
            setSparePartStatus("notFound");
            setShowFinalPopup(true);

        } else if (OrderStatus == "Confirmed" || OrderStatus =='confirmed' || OrderStatus == "Posted") {
            setSparePartStatus("Posted");
            await PaymentStatus();

        } else {
            setSparePartStatus("notCorrect");
            setShowFinalPopup(true);
            // PaymentStatus();

        }
    }

    const chickOrderStatus = async (orderStatus) => {
        // تحقق من القيمة الفارغة أو غير المعرفة
        if (orderStatus == null) {
            setSparePartStatus("notCorrect");
            setShowFinalPopup(true);
            return;
        }

        // تحويل الحالة إلى أحرف صغيرة للمقارنة الموحدة
        const status = orderStatus.toLowerCase();

        // معالجة الحالات المختلفة
        if (["approved", "sentforpayment", "inprocess", "confirmed"].includes(status)) {
            setSparePartStatus("Approved");
            await PaymentStatus();
        }
        else if (["canceled", "closed"].includes(status)) {
            setSparePartStatus("Canceled");
            setShowFinalPopup(true);
        }
        else if (["open", "delivered", "notfound"].includes(status)) {
            setSparePartStatus("notFound");
            setShowFinalPopup(true);
        }
        else if (["posted"].includes(status)) {
            setSparePartStatus("Posted");
            await PaymentStatus();
        }
        else {
            setSparePartStatus("notCorrect");
            setShowFinalPopup(true);
        }
    };


    const Fetch_SalesInvoice = async () => {
        setIsLoadingStatus(true);
        console.log('Fetch_SalesInvoice >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        try {
            await axios.request({
                url: config.controllerUrl + 'api/SparePartsSales/FetchWeb',
                data: { guid: number }, method: "POST", responseType: "json"
            }).then(async function (response) {
                console.log("Fetch_SalesInvoice:", response.data[0]);
                if (response.status >= 200 && response.status <= 300) {
                    await Fetch_SalesInvoiceTrans();
                    await GetTamaraStatusFlagSP();
                    setIsLoadingStatus(false);
                    console.log("Fetch_SalesInvoice:", response.data[0]);
                    // setSalesOrder(response.data[0]);
                    setSalesOrder(response.data[0]);
                    console.log("salesOrder: >> ", salesOrder);

                    // await chickOrderStatus(salesOrder["SparePartStatus"]);
                    console.log("response.data[0].SalesInvoiceStatusID", response.data[0].SalesInvoiceStatusID);
                    await chickOrderStatus(response.data[0].SalesInvoiceStatusID);

                    setSalesOrderAmounts(response.data[0]);
                    // var x = salesOrder.map((item,index)=>{
                    //     return  console.log('Item',item);
                    // });
                    console.log("salesOrdersalesOrder ", response.data[0].Mobile);

                    console.log("00-0-0 ", response.data[0].TermsConditionsEn);


                    // الشروط والاحكام
                    let dataTerms;
                    if ((response.data[0].TermsConditionsAr != null && response.data[0].TermsConditionsAr != '') || (response.data[0].TermsConditionsEn != null && response.data[0].TermsConditionsEn != '')) {
                        let termBefore = lang == 'ar' ? response.data[0].TermsConditionsAr : response.data[0].TermsConditionsEn;
                        let termAfter = termBefore.toString().replaceAll("\\n", "\n").split('\n');
                        dataTerms = termAfter;
                        setTermsSalesOrders(dataTerms);
                    }
                } else {
                    await chickOrderStatus("notFound");
                    // setSparePartStatus("Confirmed");
                    // setShowFinalPopup(true);
                }
            }).catch(async function (error) {

                setIsLoadingStatus(false);
                // setSparePartStatus("notFound");
                // setShowFinalPopup(true);
                await chickOrderStatus("notFound");
                console.log(error);
                throw error;
            });

        } catch (error) {
            console.log("error:", error);
            setIsLoadingStatus(false);
            // setSparePartStatus("notFound");
            // setShowFinalPopup(true);
            await chickOrderStatus("notFound");
            console.log(error);
        }
    }
    //******* paymant *********

    // * PaymentPaytabsStatusFullySI
    async function PaymentPaytabsStatusFullySI() {
        console.log('PaymentPaytabsStatusFully >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        setIsLoadingStatus(true);
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = {
                "GUID": number
            };

            await axios.request({
                baseURL: config.controllerUrl,
                // url: "sadad/api/sadad/PaymentPaytabsStatusFullySI",
                url: "sadad/api/sadad/PaymentPaytabsStatusFullySO_SP",
                headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            }).then(async response => {
                    console.log('PaymentPaytabsStatusFullySI respons:', response);

                    if (response.status >= 200 && response.status <= 299) {
                        console.log("PaymentPaytabsStatusFullySI >> response.data >>>>>>>>>>>", response.data);
                        if (response.data.SuccessMessage != null) {
                            console.log("PaymentPaytabsStatusFullySI >> response.data.Message", response.data.SuccessMessage);
                            // setShowFinalPopup(true);
                        }
                    }
                    setIsLoadingStatus(false);

                }
            )
                //     .then((response) => {
                //   console.log('GetPaymetStatues', response);
                // })
                .catch(async error => {
                    console.log('error PaymentPaytabsStatusFully:', error)
                    setIsLoadingStatus(false);
                });
        } catch (error) {
            console.log('error', error)
            setIsLoadingStatus(false);

        }
    }

    // * CreateSadadCodeSI
    async function createSadadCodeSI() {
        console.log('createSadadCodeSI >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
        setIsLoadingStatus(true);
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = {
                "GUID": number
            };

            await axios.request({
                baseURL: config.controllerUrl,
                // url: "sadad/api/sadad/CreateSadadCodeSI",
                url: "sadad/api/sadad/CreateSadadCodeSO_SP",
                headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            }).then(async response => {
                    console.log('CreateSadadCodeSI respons:', response);

                    if (response.status >= 200 && response.status <= 299) {
                        console.log("CreateSadadCodeSI >> response.data >>>>>>>>>>>", response.data);
                        // todo: اتكت من العملية
                        if (response.data.sadadMessage != null || response.data.sadadMessage != '') {
                            toast.error(trans("messages:error_after_select") + " " + trans("messages:sadad"));
                        }
                        // if (response.data.SuccessMessage != null) {
                        //     console.log("CreateSadadCodeSI >> response.data.Message", response.data.SuccessMessage);
                        //     setShowFinalPopup(true);
                        // }
                        await funcSadadNumber(response.data.SadadNumber, response.data) //
                    }
                    setIsLoadingStatus(false);
                }
            )
                .catch(async error => {
                    console.log('error CreateSadadCodeSI:', error)
                    setIsLoadingStatus(false);
                });
        } catch (error) {
            console.log('error', error)
            setIsLoadingStatus(false);

        }
    }

    const SiteSendSdadCodeFormAppFunction = async (sadad, mobile) => {

        try {
            axios.request({
                url: config.controllerUrl + 'api/SparePartsSales/SendSadadCode',
                data: { to: "966" + mobile, body: sadad }, method: "POST", responseType: "json"
            })
                .then(async function (response) {
                    console.log("Fetch_DataSalesOrderApp:", response);

                })
                .catch(function (error) {
                    console.log(error);
                });
        } catch (error) {
            console.log("error:", error);
        }

    }

    const checkCallbackPaytabs = async (paymentMethodCallback, paymentTypeCallback) => {
        if (paymentMethodCallback != null && paymentTypeCallback != null) {
            console.warn(" paymentMethodCallback >>>>>>>>>>>>>>>>>>>>>>>", paymentMethodCallback);
            console.warn(" paymentTypeCallback >>>>>>>>>>>>>>>>>>>>>>>>>", paymentTypeCallback);
            if (paymentMethodCallback.toLowerCase() == 'paytabs' && paymentTypeCallback.toLowerCase() == 'full') {
                await PaymentPaytabsStatusFullySI();

            } else if (paymentMethodCallback.toLowerCase() == 'paytabs' && paymentTypeCallback.toLowerCase() == 'partial') {
                // await paymentPaytabsStatusPartially();
            } else if (paymentMethodCallback.toLowerCase() == 'sadad' && paymentTypeCallback.toLowerCase() == 'fully') {
                // await CreateSadadCodeMT(); // * اجهز الكويري استرنق
                await createSadadCodeSI();
            } else {
                console.log("ELSE...");
            }
        }
    }

    // * AuthoriseAndCuptureAnOrderTamaraSI
    const funCaptureAPaymentTamara = async (orderId) => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var raw = {
            "orderId": orderId,
            "GUID": number,
        };
        try {
            await axios.request({
                baseURL: config.controllerUrl,
                // url: "/sadad/api/sadad/AuthoriseAndCuptureAnOrderTamaraSI",
                url: "/sadad/api/sadad/AuthoriseAndCuptureAnOrderTamaraSO_SP",
                headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            })
                .then(async response => {
                    console.log('Capture APayment Tamara:\n', response);

                    try {
                        if (response.status >= 200 && response.status <= 300) {
                            console.log(`Status Payment Full:`, response.status);
                            console.log(`Data Payment Full:\n`, response.data.url_payment);
                            console.log(`Data Payment Full:\n`, response.data.Error_messages);
                            // !! window.location.href = response.data.url_payment;
                            // await chickOrderStatus("notCorrect");
                        } else if (response.status >= 300 && response.status <= 400) {
                            setIsLoading(false);
                            toast.error(trans("error:unknown_failure") + ' ' + response.status);
                            console.log(`Status Payment Full:`, response.status);
                            console.log(`Response Payment Full:`, response);
                        } else {
                            setIsLoading(false);
                            console.log(`Status Payment Full:`, response.status);
                            console.log(`Response Payment Full:\n`, response);
                        }
                    } catch (ex) {
                        toast.error(trans("error:unknown_failure") + ' ' + response.status);
                        console.log(`Error [Catch] in Payment Tamara: \n`, ex.toString());
                    }
                })
                .catch(function (error) {
                    setIsLoading(false);
                    console.log("error:", error);
                })
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.log("error:", error);
        }
    }

    const FetchSadadNumberApp = async () => {
        try {
            await axios.request({
                url: config.controllerUrl + 'api/SparePartsSales/FetchSadadNumber',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(async function (response) {
                    console.log("setSadadInfo:", response?.data);


                    try {
                        var sadadNumber = response.data[0].sadadNumber.replaceAll('"', "");
                        console.log("sadadNumber:", sadadNumber);
                        if (sadadNumber && parseInt(sadadNumber)) {
                            var datasadad = response.data[0];
                            datasadad.sadadNumber = sadadNumber;
                            setSadadInfo(datasadad);
                        } else {

                            setSadadInfo(response?.data[0]);
                        }


                    } catch (error) {
                        setSadadInfo(response?.data[0]);
                        console.log("error sadadNumber:", error);
                    }

                    if (response.data[0].sadadNumber != null && response.data[0].sadadNumber != undefined) {

                        setShowFinalPopup(true);
                    } else {
                        await callback();
                    }

                })
                .catch(function (error) {

                    console.log(error);
                });
        } catch (error) {

            console.log("error:", error);
        }
    };

    // **** Hooks ****
    useEffect(() => {
        Fetch_SalesInvoice().then(r => console.log(r));

        // * يتم قراية الحالة من الرابط بعد القراءة من الرابط الراجع من تمارا
        const paymentStatus = new URL(window.location.href).searchParams.get("paymentStatus");
        const orderId = new URL(window.location.href).searchParams.get("orderId");

        const paymentMethodCallback = new URL(window.location.href).searchParams.get("PaymentMethod");
        const paymentTypeCallback = new URL(window.location.href).searchParams.get("PaymentType");

        checkCallbackPaytabs(paymentMethodCallback, paymentTypeCallback).then(val => console.log(val));

        if (paymentStatus) {
            console.warn(" paymentStatus >>>>>>>>>>>>>>>>>>>>>>>", paymentStatus);
            console.warn(" paymentStatus >>>>>>>>>>>>>>>>>>>>>>>", orderId);
        }

        if (paymentStatus == 'Error') {
            console.warn(" paymentStatus >>>>>>>>>>>>>>Error>>>>>>>>>>>>>>>", paymentStatus);
            console.warn(" orderId >>>>>>>>>>>>>>>>>>>>Error>>>>>>>>>>>>>>>", orderId);
            // toast.success(trans("messages:copied_successfully"));
            toast.warning(trans(lang == 'ar'
                ? "حصل خطاء يرجى مراجعة تمارا!"
                : "An error occurred, please check with Tamara!"));
        }

        if (paymentStatus == 'approved') {
            console.warn(" orderId >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", orderId);
            funCaptureAPaymentTamara(orderId);
            // setShowFinalPopup(true);
        }
        console.log('End useEffect:');
    }, []);

    const callback = useCallback(async () => {
        setIsLoadingStatus(true)
        try {
            axios.request({
                url: config.controllerUrl + 'api/SparePartsSales/FetchSalesOrderTrans',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    console.log("Fetch_SalesOrderTrans:", response);
                    setOrderTrans(response.data);
                    setIsLoadingStatus(false)

                })
                .catch(function (error) {
                    console.log(error);
                    setIsLoadingStatus(false)
                });
        } catch (error) {
            setIsLoadingStatus(false)
            console.log("error:", error);
        }

        try {
            axios.request({
                url: config.controllerUrl + 'api/SparePartsSales/FetchCustInfo',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    console.log("setOrderCustInfo:", response);
                    setOrderCustInfo(response.data);


                })
                .catch(function (error) {

                    console.log(error);
                });
        } catch (error) {

            console.log("error:", error);
        }


        try {
            axios.request({
                url: config.controllerUrl + 'api/SparePartsSales/FetchAuthorized',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    console.log("setOrderAuthorized:", response);
                    setOrderAuthorized(response.data);


                })
                .catch(function (error) {

                    console.log(error);
                });
        } catch (error) {

            console.log("error:", error);
        }

        try {
            axios.request({
                url: config.controllerUrl + 'api/SparePartsSales/FetchAmounts',
                data: { guid: number }, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    console.log("setSalesOrderAmounts:", response);
                    setSalesOrderAmounts(response.data[0]);


                })
                .catch(function (error) {

                    console.log(error);
                });
        } catch (error) {

            console.log("error:", error);
        }


        // try {
        //     const Body = {
        //         "name": "fetch_termsSO", "values": {
        //             "GUID": number
        //         },
        //     }
        //     axios.request({
        //         url: config.baseURLSadad + 'func', data: Body, method: "POST", responseType: "json"
        //     })
        //         .then(function (response) {
        //             console.log("fetch_termsSalesOrders:", response);
        //             setTermsSalesOrders(response.data);
        //
        //         })
        //         .catch(function (error) {
        //             console.log(error);
        //         });
        // } catch (error) {
        //     console.log("error:", error);
        // }

    }, []);


    // ***** **** ****
    return (isLoadingStatus ? (
        <>
            <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"10rem"}
                      containerClassName={"my-5"} className={"flex my-5"} inline={false}/>

            <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"50rem"}
                      containerClassName={"my-5"} className={"flex my-5"} inline={false}/>

            <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"50rem"}
                      containerClassName={"my-5"} className={"flex my-5"} inline={false}/>

            <Skeleton count={10} borderRadius={"1rem"} width={"70%"} height={"5rem"}
                      containerClassName={"my-5"} className={"flex my-5"} inline={false}/>

            <Skeleton count={2} borderRadius={"1rem"} width={"50%"} height={"10rem"}
                      containerClassName={"flex flex-row nice-gap-2rem my-20"}
                      className={"flex flex-row nice-gap-2rem my-20"} inline={true}/>
        </>
    ) : (
        <>
            < div className=" unselectable ">
                <section className="cart  h-full  ">
                    <div className=" p-10 bg-black text-white">
                        <div className="sales-header">
                            <img src="/assets/logo/HassanJ-LOGO_white.svg" alt='discount' className=""/>

                            <h2 className="text-40 py-5 text-white text-center font-bold nice-apply-theme text-capitalize">
                                {trans("new:spare_part")}
                            </h2>

                            <div className={"change-lang text-bold text-24"}
                                 onClick={() => {
                                     var bb = (window.location.pathname.includes("/en") || window.location.pathname.includes("/ar")) ? window.location.href.replace(/en|ar/, trans("mobileCommon:changeLangCode")) : window.location.origin + "/" + trans("mobileCommon:changeLangCode") + window.location.pathname;
                                     console.log("......:", bb)
                                     window.location = bb;
                                 }}>{trans("mobileCommon:changeLang")}
                            </div>
                        </div>
                    </div>
                    {/*   */}
                    <div className="nice-container flex flex-col nice-gap-1rem cart-item-radius bg-white">
                        <div className="flex flex-row nice-gap-1rem mt-20">
                        <span
                            className="text-30 text-bold text-nowrap text-capitalize"> {trans('new:invoice_number_mt')}: </span>
                            <span className="text-30 text-bold"> {salesOrder.SalesInvoiceID} </span>
                        </div>

                        <div className="flex flex-row nice-gap-1rem">
                            <span className="text-30 text-nowrap text-capitalize"> {trans('new:name')}: </span>
                            <span className="text-30 ">
                                {lang == 'ar' ? salesOrder.DescriptionAr : salesOrder.DescriptionEn}
                        </span>
                        </div>
                        {
                            salesOrder?.Mobile != null
                                ? <div className="flex flex-row nice-gap-1rem">
                                <span className="text-30 text-nowrap text-capitalize">
                                  {trans('new:mobile')}:
                                </span>
                                    <span className="text-24 text-bold text-info-light language-en" dir="ltr">
                                    <a
                                        className="text-30 text-bold text-info-light language-en border-line-b"
                                        href={'tel:' + salesOrder?.Mobile}
                                    >
                                        {salesOrder?.Mobile}
                                    </a>
                                </span>
                                </div> : <></>
                        }
                        <div className="flex flex-row nice-gap-1rem">
                        <span className="text-30 text-nowrap text-capitalize">
                          {trans('jobCard:date_time')}:
                        </span>
                            <span className="text-30 language-en">
                          {salesOrder.SalesInvoiceDate != null ? formatDateTime(salesOrder.SalesInvoiceDate) : ""}
                        </span>
                        </div>

                        <div className="flex flex-row nice-gap-1rem">
                        <span className="text-30 text-nowrap text-capitalize">
                          {trans('new:Spare_parts_consultant')}:
                        </span>
                            <span className="text-30 language-en">
                             {lang == 'ar' ? salesOrder.ConsultantAr : salesOrder.ConsultantEn}
                        </span>
                        </div>

                        <div className="flex flex-row nice-gap-1rem">
                        <span className="text-30 text-nowrap text-capitalize">
                            {trans('new:mobile')}:
                        </span>
                            <span className="text-24 text-bold text-info-light language-en" dir="ltr">
                            <a className="text-30 text-bold text-info-light language-en border-line-b"
                               href={'tel:' + salesOrder?.MobileConsultant}
                            >
                                {salesOrder.MobileConsultant}
                            </a>
                        </span>
                        </div>

                        {/*         */}
                        {
                            showInfo
                                ? (
                                    <>
                                        <div className="flex flex-row nice-gap-1rem mt-20">
                                            <span
                                                className="text-40 text-bold text-nowrap text-capitalize text-underline">
                                                {trans('new:spare_parts_required')}
                                            </span>
                                        </div>

                                        <>
                                            <br/>
                                            <br/>
                                            <br/>
                                        </>

                                        <div className="flex flex-row nice-gap-1rem">
                                            <div className="flex flex-row nice-gap-1rem width-p-50">
                                            <span className="text-30 text-nowrap text-bold text-capitalize ">
                                                {/* {trans('mobileCommon:service_no')} */}
                                                {trans("new:description")}
                                            </span>
                                            </div>
                                            <div className="flex flex-row nice-gap-1rem width-p-50">
                                            <span
                                                className="text-30 font-bold text-nowrap text-capitalize center-item width-p-25">
                                                {/*{trans('jobCard:number')}*/}
                                                {trans("new:qty")}
                                            </span>

                                                <span
                                                    className="text-30 font-bold text-nowrap text-capitalize center-item width-p-50">
                                                {/*{trans('jobCard:cost')}*/}
                                                    {trans("new:cost")}
                                            </span>

                                                {/*<span*/}
                                                {/*    className="text-30 font-bold text-nowrap text-capitalize center-item width-p-25">*/}
                                                {/*                    /!*{trans('jobCard:agreement')}*!/*/}
                                                {/*    {trans("new:total")}*/}
                                                {/*                  </span>*/}
                                            </div>
                                        </div>

                                        {
                                            categories.map((item, index) => {
                                                return (
                                                    <div key={index}>
                                                        <div className="flex flex-row nice-gap-1rem">
                                                            <div className="flex flex-row nice-gap-1rem width-p-50">
                                                            <span
                                                                className="text-30 text-nowrap text-capitalize ">
                                                                {/* {trans('mobileCommon:service_no')} */}
                                                                {lang == 'en' ? item.Description : item.DescriptionAr}
                                                            </span>
                                                            </div>
                                                            <div className="flex flex-row nice-gap-1rem width-p-50">
                                                            <span
                                                                className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                                                {/*{trans('jobCard:number')}*/}
                                                                {item.Qty}
                                                            </span>

                                                                <span
                                                                    className="text-30 text-nowrap text-capitalize center-item width-p-50">
                                                                {/*{trans('jobCard:cost')}*/}
                                                                    <Price price={item.NetTotalBeforeDisc} showZero={true}/>
                                                            </span>

                                                                {/*<span*/}
                                                                {/*    className="text-30 text-nowrap text-capitalize center-item width-p-25">*/}
                                                                {/*    /!*{trans('jobCard:agreement')}*!/*/}
                                                                {/*    {item.NetTotalBeforeDisc * 10}{trans('new:rial')}*/}
                                                                {/*  </span>*/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </>
                                )
                                : (
                                    <>
                                        <div className="flex flex-row nice-gap-1rem">
                                        <span
                                            className="text-40 text-bold text-nowrap text-capitalize text-underline">
                                        </span>
                                        </div>
                                    </>
                                )
                        }

                        {/*  show  */}
                        {
                            agreementShow &&
                            <Link to={'#'} className="flex flex-col items-center  mt-5 p-10"
                                  onClick={() => {
                                      setShowInfo(!showInfo);
                                  }}>
                                {
                                    (showInfo == true) ? (
                                            <>
                                                <span
                                                    className="text-20 my-10 text-capitalize">{trans("new:hide_varieties_mt")}</span>
                                                <img src="/assets/icons/arrow-down.svg"
                                                     className="object-contain rotate-180"/>
                                                <img src="/assets/icons/arrow-down.svg"
                                                     className="object-contain rotate-180"/>
                                            </>
                                        ) :
                                        (
                                            <>
                                                <span
                                                    className="text-20 my-10 text-capitalize">{trans("new:show_varieties_mt")}</span>
                                                <img src="/assets/icons/arrow-down.svg" className="object-contain"/>
                                                <img src="/assets/icons/arrow-down.svg" className="object-contain"/>
                                            </>
                                        )
                                }
                            </Link>
                        }

                        {/*  butom  */}
                    </div>

                    {
                        salesOrderAmounts && <>
                            <div className=" my-10">
                                <div className="flex flex-col nice-gap-2rem">
                                    <div className="flex flex-row justify-between items-center nice-container">
                                        <h3 className="text-40 font-bold text-black"> {trans("new:pay_method")}</h3>
                                    </div>

                                    <div
                                        className={"flex flex-row nice-gap-1rem   p-5 " + (paymentType == 1 ? "bg-gray-light " : "")}>
                                        <label
                                            className={" text-30 text-bold  flex flex-row nice-gap-1rem pr-10 pl-10  items-center"}>
                                            <input type='radio' checked={paymentType == 1 ? true : false}
                                                   name='paymentType'
                                                   onClick={() => {
                                                       setPaymentType(1);
                                                   }}
                                                   onChange={() => {
                                                       console.log("<< PaymentType >>: ", paymentType);
                                                   }}

                                                   id="primary"
                                                   disabled={sadadInfo?.invoiceID ? true : false}
                                            />
                                            {trans("new:pay_all")}

                                        </label>
                                        <div className="flex flex-row items-center  ">
                                            <img className="cart-payment-icon object-contain"
                                                 src="/assets/icons/companies/master-card-3.png" alt={"master"}/>
                                            <img className="cart-payment-icon object-contain"
                                                 src="/assets/icons/companies/visa-3.png" alt={"visa"}/>
                                            <img className="cart-payment-icon object-contain"
                                                 src="/assets/icons/companies/mada-3.png" alt={"mada"}/>
                                            {/*<img className="cart-payment-icon object-contain" src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />*/}
                                        </div>
                                    </div>

                                    <div
                                        className={"flex flex-row nice-gap-1rem   p-5 " + (paymentType == 2 ? "bg-gray-light " : "")}>
                                        <label
                                            className={" text-30 text-bold  flex flex-row nice-gap-1rem pr-10 pl-10  items-center"}>
                                            <input type='radio' checked={paymentType == 2 ? true : false}
                                                   name='paymentType'
                                                   onClick={() => {
                                                       setPaymentType(2);
                                                   }}
                                                   onChange={() => {
                                                       console.log("<< PaymentType >>: ", paymentType);
                                                   }}
                                                   id="primary"
                                                   disabled={sadadInfo?.invoiceID ? true : false}
                                            />
                                            {trans("new:pay_all")}

                                        </label>
                                        <div className="flex flex-row items-center  ">
                                            <img className="cart-payment-icon object-contain"
                                                 src={lang == 'ar' ? "/assets/icons/companies/SADAD-Logo.png" : "/assets/icons/companies/SADAD-Logo.png"}
                                                 alt={"SADAD"}/>
                                        </div>
                                    </div>

                                    <div
                                        className={"flex flex-col nice-gap-1rem  p-5 " + (paymentType == 3 ? "bg-gray-light my-10" : "")}>
                                        <label
                                            className={" text-30 text-bold  flex flex-row nice-gap-1rem pr-10 pl-10  items-center"}>
                                            <input type='radio' checked={paymentType == 3 ? true : false}
                                                   name='paymentType'
                                                   onClick={() => {

                                                       setPaymentType(3);
                                                   }}
                                                   onChange={() => {
                                                       console.log("<< PaymentType >>: ", paymentType);
                                                   }}

                                                   id="primary"
                                                   disabled={checkTamarClose === true ? true : false}
                                            />

                                            {trans("jobCard:byTamara")}

                                            <div className="flex flex-row  ">
                                                <img className="cart-payment-icon object-contain"
                                                     src={lang == 'ar'
                                                         ? "/assets/icons/companies/tamara/AR-tamara.svg"
                                                         : "/assets/icons/companies/tamara/En-tamara.svg"}
                                                     alt={""}/>
                                            </div>

                                        </label>
                                        <label className={" text-30  flex flex-row  pr-20 pl-20"}>
                                            {trans("jobCard:byTamara3")}
                                        </label>
                                        <label className={" text-30  flex flex-row pr-20 pl-20 "}>
                                            {trans("jobCard:byTamara4")}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-column bg-secondary-light items-center nice-shadow-2 my-5"></div>

                            <div className="cart-container bg-light cart-item-radius-top">
                                <section className="cart-bill bg-white nice-container">
                                    <div className="text-30 mb-20"

                                         onClick={() => {
                                             // setShowTermsPopup(true);
                                             console.warn("termsSalesOrders.length != 0", termsSalesOrders.length);
                                             if (termsSalesOrders.length !== 0) {
                                                 setShowTermsPopup(true);
                                             }
                                         }}
                                    >
                                        {trans("mobileCommon:cart_agreement_part1")}&nbsp;
                                        <span className="text-info-light text-30 mx-1">
                                            {trans("mobileCommon:cart_agreement_part2")}
                                        </span>
                                        {trans("mobileCommon:cart_agreement_part3")}
                                    </div>

                                    <div className="cart-bill-row">
                                        <span
                                            className=" cart-bill-row-item text-capitalize">{trans('mobileCommon:total')}</span>
                                        <span className="cart-bill-row-item text-bold">
                                            <Price price={salesOrder?.NetTotalExclTax}/></span>
                                    </div>

                                    <div className="cart-bill-row">
                                        <span
                                            className=" cart-bill-row-item text-capitalize">{trans("mobileCommon:tax") + " (15%) "}</span>
                                        <span className="cart-bill-row-item text-bold">
                                            <Price price={salesOrder?.TotalTax}/></span>
                                    </div>

                                    <div className="cart-bill-row ">
                                        <span
                                            className=" cart-bill-row-item text-capitalize">{trans("mobileCommon:deduction")}</span>
                                        <span className="cart-bill-row-item text-bold">
                                            <Price price={salesOrder?.DiscountTotal} showZero={true}/></span>
                                    </div>

                                    <div className="cart-bill-line my-4"></div>

                                    {/* الاجمالي */}
                                    <div className="cart-bill-row my-10">
                                    <span className="font-bold text-super-gray">
                                        {trans("mobileCommon:full_total")}
                                    </span>
                                        <div className="flex flex-row">
                                        <span className="text-30 cart-bill-row-item mx-2">
                                            {trans("mobileCommon:tax_note")}
                                        </span>
                                            <span className="text-30 cart-bill-row-item text-bold">
                                            <Price price={salesOrder?.NetTotalAfterDisc}/>
                                        </span>
                                        </div>
                                    </div>

                                    {/*BTN*/}
                                    {
                                        chickBTNPay == true
                                            ? <>
                                                {
                                                    isLoading
                                                        ? <div className="text-white text-20 basis-2/4 my-10 order-1" dir="rtl">
                                                            <SimpleButton
                                                                className="text-white bg-gray text-20 basis-2/4 my-10 order-1 mx-24"
                                                                isLoading={isLoading}
                                                                title={''}
                                                                onClick={() => {
                                                                }}
                                                            />
                                                        </div>
                                                        : isPayed == 1
                                                            ?
                                                            <div className="flex flex-row nice-gap-2rem 15" dir="rtl">
                                                                <SimpleButton
                                                                    className="text-white bg-primary text-20  basis-2/4 my-10 order-1 padding-inline-0"
                                                                    isLoading={isLoading}
                                                                    title={trans("complete_order")}
                                                                    onClick={() => {
                                                                        console.log("Click SOSP ..");
                                                                        handelGoCheckSms();
                                                                        // if (onClick) {
                                                                        //     onClick();
                                                                        // }
                                                                    }}
                                                                />
                                                                <SimpleButton
                                                                    className="text-white bg-black basis-2/4 my-10"
                                                                    iconPath={'/assets/icons/apple-pay.png'}
                                                                    onClick={() => {
                                                                        handelGoCheckSms(true);
                                                                        console.info("apple-pay: ", paymentType.toString());
                                                                        // setShowFinalPopup(true);
                                                                        // window.location.replace("https://secure.paytabs.sa/payment/request/invoice/1288115/B2C960375A1C475BBF7C70216CB629A9");
                                                                    }}
                                                                />
                                                            </div>
                                                            : <div className="flex-row nice-gap-1rem my-15">
                                                                <div className="cart-finalized-code-Custom px-4"
                                                                     onClick={() => {
                                                                         if (sadadInfo && sadadInfo?.SadadNumber != null && sadadInfo.SadadNumber != 0) {
                                                                             navigator.clipboard.writeText(sadadInfo?.SadadNumber ? sadadInfo?.SadadNumber : "");
                                                                             toast.success(trans("messages:copied_successfully"));
                                                                         }
                                                                     }}
                                                                >
                                                            <span className="text-34 font-bold text-white mx-2">
                                                                {trans("new:Prepaid")}
                                                                {
                                                                    (sadadInfo && sadadInfo.sadadNumber)
                                                                        ? " " + trans('jobCard:agreement_number') + ":"
                                                                        : ""
                                                                }
                                                            </span>

                                                                    <code className="text-white text-30 language-en">
                                                                        {
                                                                            (sadadInfo && sadadInfo.sadadNumber)
                                                                                ? (sadadInfo?.SadadNumber ? sadadInfo?.SadadNumber : "")
                                                                                : postedDate && moment(postedDate).format('hh:mm a').toUpperCase()

                                                                        }
                                                                    </code>

                                                                    <code className="text-white text-30">
                                                                        {sadadInfo && sadadInfo.sadadNumber
                                                                            ? <img src="/assets/icons/copy.svg" alt='copy'/>
                                                                            : postedDate && moment(postedDate).format('DD/MM/yyyy')
                                                                        }
                                                                    </code>

                                                                </div>
                                                            </div>
                                                }
                                            </>
                                            : <></>
                                    }

                                </section>
                            </div>
                        </>
                    }

                    {/*    */}
                </section>

                <Suspense>
                    <PopupWithHeading
                        className={"popup-container-auto"}
                        backButton={true}
                        show={showPopup}
                        title={optionTitle}
                        onStatusChange={(status) => {

                            setShowPopup(false);
                        }}
                    >
                        <SMSCheck
                            mobile={salesOrder && salesOrder?.Mobile}
                            osama
                            onSucess={onSucess}
                        />
                    </PopupWithHeading>

                    <Popup show={showFinalPopup}>
                        <div className="w-full h-full flex justify-center items-center">
                            <div className="cart-finalized" ref={popRef}>
                                {/* <div className="popup-close nice-select-none" onClick={() => {

                                setShowFinalPopup(false);

                            }}>
                                {"x"}
                            </div> */}
                                <div className="cart-finalized-container">
                                    <img src="/assets/images/finalized.svg"/>
                                </div>
                                <div className="flex flex-wrap justify-center">
                                    <span
                                        className="text-34 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                                    <span className="text-34 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                                </div>
                                {popupSectionCallback(SparePartStatus)}
                            </div>
                        </div>
                    </Popup>

                    <Popup show={showTermsPopup}>
                        <div className="w-full h-full flex justify-center items-center">
                            <div className="cart-finalized" ref={popRef}>
                                <div className="popup-close nice-select-none" onClick={() => {

                                    setShowTermsPopup(false);

                                }}>
                                    {"x"}
                                </div>


                            </div>
                        </div>
                    </Popup>


                    <PopupWithHeading
                        terms={true}
                        backButton={false}
                        show={showTermsPopup}
                        title={trans("mobileCommon:cart_agreement_part2")}
                        onStatusChange={(status) => {
                            setShowTermsPopup(false);
                        }}
                    >

                        <ul className="my-20 p-20 flex flex-col top-margin-t">
                            {

                                termsSalesOrders.map((term, index) => {
                                    return (

                                        term &&
                                        <li key={index} className={"text-30  my-5 "}>
                                            {
                                                !term.includes("<>") &&
                                                <>
                                                    <span className="text-30 text-bold ">{term}</span>
                                                </>
                                            }

                                            {
                                                term.includes("<>") &&
                                                term.split('<>').slice(1).map((termsub, indexsub) => {
                                                    return (
                                                        termsub &&
                                                        <h6 key={indexsub} className="text-30 text-bold ">{"-"} <span
                                                            className="text-30 text-bold ">{termsub}</span></h6>

                                                    );
                                                })
                                            }
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </PopupWithHeading>

                </Suspense>
            </div>
        </>
    ));
};

export default SparePartsSalesPage;